import React, { useState } from 'react';

function DeleteProject({ handleDeleteProject }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <>
      <button
        className={`btn btn--lg module-hover-root ${
          showDeleteModal ? 'btn--white' : 'btn--pip-red'
        }`}
        type="button"
        onClick={() => setShowDeleteModal(!showDeleteModal)}
      >
        <span className="btn__content">
          <span className="btn__text">
            {showDeleteModal ? 'Nevermind' : 'Delete Project'}
          </span>
        </span>
      </button>
      {showDeleteModal && (
        <div className="u--margin-top-30">
          <p>
            <b>
              Are you sure you want to delete this project? This cannot be
              undone.
            </b>
          </p>
          <button
            className="btn btn--lg module-hover-root btn--pip-red"
            type="button"
            onClick={() => handleDeleteProject()}
          >
            <span className="btn__content">
              <span className="btn__text">Yes, Delete Project</span>
            </span>
          </button>
        </div>
      )}
    </>
  );
}

export default DeleteProject;
